import { useQuery } from "react-query";

import { listTargetSessions } from "api/targets";
import { GET_TARGET_SESSIONS, STALE_TIME_1_MINUTES } from "@constants/reactQueryKeys";

const useListTargetSessions = (targetId: number) => {
  const {
    data: response,
    isLoading,
    error,
    ...rest
  } = useQuery([GET_TARGET_SESSIONS, targetId], () => listTargetSessions(targetId), {
    enabled: !!targetId,
    staleTime: STALE_TIME_1_MINUTES,
    refetchOnWindowFocus: false,
    retry: 2,
  });

  return {
    targetSessions: response?.data ?? [],
    isLoadingTargetSessions: isLoading,
    targetSessionsError: error,
    ...rest,
  };
};

export default useListTargetSessions;
